import React from "react";
import { useTranslation } from "react-i18next";
import "../App.css";
import "../utils/styles/PageAnimations.css";

function AppPage() {
  const { t } = useTranslation();

  return (
    <div
      className="app-page page-animated"
      style={{
        padding: "5rem 2rem",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      <h1
        className="animate-up delay-1"
        style={{
          marginBottom: "4rem",
          textAlign: "center",
          fontSize: "3rem",
          color: "#1d2b45",
        }}
      >
        {t("appPage.title")}
      </h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: "4rem",
          alignItems: "center",
        }}
      >
        {/* TEXT CARD */}
        <div
          className="animate-left delay-2 hover-card"
          style={{
            background: "rgba(255,255,255,0.92)",
            borderRadius: "24px",
            padding: "2.5rem",
            boxShadow: "0 10px 30px rgba(31,152,244,0.08)",
            border: "1px solid rgba(3,122,246,0.08)",
            backdropFilter: "blur(10px)",
          }}
        >
          <h2
            style={{
              marginBottom: "1.5rem",
              fontSize: "2rem",
              color: "#1d2b45",
            }}
          >
            {t("appPage.featureTitle")}
          </h2>

          <p
            style={{
              fontSize: "1.1rem",
              lineHeight: "1.9",
              color: "#42526b",
            }}
          >
            {t("appPage.featureDescription")}
          </p>

          <div
            style={{
              display: "flex",
              gap: "1rem",
              marginTop: "2rem",
              flexWrap: "wrap",
            }}
          >
            <div
              className="hover-card"
              style={{
                background: "#f7fbff",
                border: "1px solid rgba(3,122,246,0.08)",
                padding: "0.9rem 1.2rem",
                borderRadius: "14px",
                color: "#037af6",
                fontWeight: "600",
              }}
            >
              ✅ Shared Lists
            </div>

            <div
              className="hover-card"
              style={{
                background: "#f7fbff",
                border: "1px solid rgba(3,122,246,0.08)",
                padding: "0.9rem 1.2rem",
                borderRadius: "14px",
                color: "#037af6",
                fontWeight: "600",
              }}
            >
              📅 Smart Planning
            </div>

            <div
              className="hover-card"
              style={{
                background: "#f7fbff",
                border: "1px solid rgba(3,122,246,0.08)",
                padding: "0.9rem 1.2rem",
                borderRadius: "14px",
                color: "#037af6",
                fontWeight: "600",
              }}
            >
              🤝 Collaboration
            </div>
          </div>
        </div>

        {/* IMAGE */}
        <div
          className="animate-right delay-3"
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src="/images/screens/app.png"
            alt="Onenizer App"
            className="hover-image"
            style={{
              width: "100%",
              maxWidth: "520px",
              borderRadius: "28px",
              background: "#fff",
              padding: "1rem",
              boxShadow: "0 20px 50px rgba(0,0,0,0.08)",
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default AppPage;
